<template>
  <v-container fluid>
    <v-flex xs12>
      <div>
        <excel-upload @update-filedata="val => (fileData = val)" @sendFile="uploadFileToServer" />
        <v-data-table
          v-if="fileData && fileData.headers"
          style="margin-top:20px;"
          :headers="tableData.headers"
          :items="tableData.data"
          class="elevation-1"
        >
          <v-progress-linear slot="progress" color="blue" indeterminate />
          <template slot="items" slot-scope="props">
            <td
              v-for="(col, index) in tableData.headers"
              :key="index">
              {{ props.item[col.value] }}
            </td>
          </template>
        </v-data-table>
        <v-btn class="ma-2" outlined color="indigo" @click.native="ValidateLayout">Validate FF</v-btn>
        <v-btn class="ma-2" outlined color="indigo" @click.native="GenMap">Gen Map</v-btn>
        <v-btn class="ma-2" outlined color="indigo" @click.native="ViewMapper">ViewMapper</v-btn>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
/* globals Store */
import ExcelUpload from '@/vue-dlb/components/excel/ExcelUpload.vue';
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import { mapState } from "vuex";
require('date-utils');

export default {
  name: 'ExcelUploadComponent',
  components: {
    ExcelUpload,
  },
  data() {
    return {
      fileData: {},
      uploadHeader: {
        header: [
          {id: 'BIZ_KUBUN', type: 'STRING', size: 10},
          {id: 'FILE_NAME', type: 'STRING', size: 100},
          {id: 'File_Url', type: 'url', size: 100},
          {id: 'DELETE_YN', type: 'STRING', size: 1},
          {id: 'SITE_CODE', type: 'STRING', size: 10}
        ],
        data: {
          BIZ_KUBUN: '',
          FILE_NAME: '',
          File_Url: '',
          DELETE_YN: '',
          SITE_CODE: ''
        },
      },
      validateFFHeader: {
        header: [
          {id: 'FFTYPE', type: 'STRING', size: 2},
          {id: 'TX_DATE', type: 'STRING', size: 8},
          {id: 'IND_CD', type: 'STRING', size: 4},
          {id: 'MST_MSG_ID', type: 'STRING', size: 20},
          {id: 'MST_MSG_VER', type: 'STRING', size: 20},
          {id: 'MST_MSG_SNDR', type: 'STRING', size: 20},
          {id: 'MST_MSG_RCVR', type: 'STRING', size: 20},
          {id: 'FFCSV_FILE', type: 'STRING', size: 100},
          {id: 'SITE_CODE', type: 'STRING', size: 20},
          {id: 'S_SIMILARITY', type: 'STRING', size: 5}
        ],
        data: {
          FFTYPE: '',
          TX_DATE: '',
          IND_CD: '',
          MST_MSG_ID: '',
          MST_MSG_VER: '',
          MST_MSG_SNDR: '',
          MST_MSG_RCVR: '',
          FFCSV_FILE: '',
          SITE_CODE: '',
          S_SIMILARITY: ''
        },
      }
    };
  },
  computed: {
    ...mapState("excel", {
      dataset01: "dataSet01",
      dataset02: "dataSet02",
      dataset03: "dataSet03",
      pagination: "pagination",
      loading: "loading",
      mode: "mode",
      snackbar: "snackbar",
      notice: "notice"
    }),
    tableData() {
      if (!this.fileData) {
        return {
          headers: [],
          data: [],
        };
      }

      const headers = [];
      const cols = this.fileData.headers || [];
      const rawData = this.fileData.data || [];

      for (let i = 0, len = cols.length; i < len; i += 1) {
        headers.push({
          text: cols[i],
          value: cols[i],
        });
      }

      return { headers, data: rawData };
    },
  },
  methods: {
    uploadFileToServer (file) {
      console.log("--------- uploadFileToServer ----------");
      console.log('upload File Name:' + file.name);
      let condSet = new ObjDataSet("condSet");
      const trSet01 = new ObjTrSet("trSet01");
      this.uploadHeader.data.BIZ_KUBUN = 'MAP';
      this.uploadHeader.data.FILE_NAME = file.name;
      this.uploadHeader.data.DELETE_YN = 'N';
      this.uploadHeader.data.SITE_CODE = new Date().toFormat('YYYYMMDDHH24MISS');
      condSet = this.appUtil.addDataHeader(this.uploadHeader, condSet);
      trSet01.AddDataSet("I", "DS01", condSet);

      const formData = new FormData();
      formData.append('file', file, file.name);
      formData.append('trSet', JSON.stringify(trSet01));
      Store.dispatch("excel/transFile", formData);
    },
    ValidateLayout () {
      console.log("--------- ValidateLayout ----------");
      const dataSet01 = new ObjDataSet("dataSet01");
      let condSet = new ObjDataSet("condSet");
      const trSet01 = new ObjTrSet("trSet01");
      this.validateFFHeader.data.FFTYPE = 'P';  // F-FixedLength, P-Prefix
      this.validateFFHeader.data.TX_DATE = '20191104';
      this.validateFFHeader.data.IND_CD = 'SMLK';
      this.validateFFHeader.data.MST_MSG_ID = 'IFTMBF';
      this.validateFFHeader.data.MST_MSG_VER = 'UND99B';
      this.validateFFHeader.data.MST_MSG_SNDR = '';
      this.validateFFHeader.data.MST_MSG_RCVR = '';
      this.validateFFHeader.data.FFCSV_FILE = this.uploadHeader.data.FILE_NAME;
      this.validateFFHeader.data.SITE_CODE = this.uploadHeader.data.SITE_CODE;
      this.validateFFHeader.data.S_SIMILARITY = '';
      condSet = this.appUtil.addDataHeader(this.validateFFHeader, condSet);
      trSet01.AddDataSet("I", "DS01", condSet);
      trSet01.AddDataSet("O", "DS02", dataSet01);
      trSet01.TranID = "MapHelpManager";
      trSet01.CallMethod = "ValidateFlatFileLayout";

      Store.dispatch("excel/validateFile", trSet01);
    },
    GenMap () {
      console.log("--------- GenMap ----------");
      const dataSet02 = new ObjDataSet("dataSet02");
      let condSet = new ObjDataSet("condSet");
      const trSet01 = new ObjTrSet("trSet01");
      this.validateFFHeader.data.FFTYPE = 'P';  // F-FixedLength, P-Prefix
      this.validateFFHeader.data.TX_DATE = '20191104';
      this.validateFFHeader.data.IND_CD = 'SMLK';
      this.validateFFHeader.data.MST_MSG_ID = 'IFTMBF';
      this.validateFFHeader.data.MST_MSG_VER = 'UND99B';
      this.validateFFHeader.data.MST_MSG_SNDR = '';
      this.validateFFHeader.data.MST_MSG_RCVR = '';
      this.validateFFHeader.data.FFCSV_FILE = this.uploadHeader.data.FILE_NAME;
      this.validateFFHeader.data.SITE_CODE = this.uploadHeader.data.SITE_CODE;
      this.validateFFHeader.data.S_SIMILARITY = '';
      condSet = this.appUtil.addDataHeader(this.validateFFHeader, condSet);
      trSet01.AddDataSet("I", "DS01", condSet);
      trSet01.AddDataSet("O", "DS02", dataSet02);
      trSet01.TranID = "MapHelpManager";
      trSet01.CallMethod = "outboundMapperCreate";

      Store.dispatch("excel/GenerateMapper", trSet01);
    },
    ViewMapper () {
      // 파일명 임시
      let scannerfile = '/dlb/WebInput/edi_mapper/20200114142023/iftmbf_und99b_s_smlk_scanner.cpp';
      let mapperfile = '/dlb/WebInput/edi_mapper/20200114142023/iftmbf_und99b_s_smlk_mapper.cpp';
      console.log('scannerfile:' + scannerfile);
      console.log('mapperfile:' + mapperfile);
      //this.$router.push({ name: 'EDIViewer', params: {"edipath": edifile, "bizpath": bizfile }})
      //let routeData = this.$router.resolve({name: 'EDIViewer', query: {"edipath": edifile, "bizpath": bizfile }});
      let routeData = this.$router.resolve({name: 'MapEditor', query: {"scanner": scannerfile, "mapper": mapperfile }});
      window.open(routeData.href, '_blank');
    }

  }
};
</script>
